import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import Select from 'react-select';
import { SelectStyles } from '../../../../style/components/react-select';

const SelectInput = ({
  id,
  handleInputChange,
  metaTag,
  fileIndex,
  tagIndex,
  isSearchable,
  userInput,
  intl
}) => {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    if (
      metaTag.list &&
      Array.isArray(metaTag.list) &&
      metaTag.list.length > 0
    ) {
      const temp = [];
      metaTag.list.map((option) => {
        if (typeof option == 'string') {
          temp.push({ label: option, value: option });
        }
      });
      setOptions(temp);
    }
  }, [metaTag.list]);

  return (
    <Select
      id={'meta_' + metaTag.meta.id}
      key={id}
      options={options}
      name={metaTag.meta.name}
      value={options.filter(function (option) {
        return option.value === userInput;
      })}
      searchable={isSearchable ? true : false}
      openOnClick
      onChange={(e) => {
        handleInputChange(fileIndex, tagIndex, e.value);
      }}
      simpleValue
      placeholder={intl.formatMessage({ id: 'general.select' })}
      styles={SelectStyles}
    />
  );
};

export default injectIntl(SelectInput);
